import { createContext } from "react";
import { EmployeeToken, UserToken } from "../../amorg-common";
import React from "react";
import { ThemeProvider } from "styled-components";
import { colors, ColorSystem } from "../../designSystem/colors/color";
import { applyPartnerColors } from "../../designSystem/colors/CustomizableColors";
import { AmorgStyles, amorgStyles } from "../../designSystem/styles/amorgStyles";

type EmployeePortalPageContextType = {
    user:EmployeeToken | UserToken | null,
    colors:ColorSystem,
    styles:AmorgStyles
}

export const EmployeePortalPageContext = createContext<EmployeePortalPageContextType>({
    user:null, 
    colors, 
    styles:amorgStyles(colors)
});

type EmployeePortalPageProviderProps = {
    user: EmployeeToken | UserToken | null,
    children?:React.ReactNode
}
export function EmployeePortalPageProvider(props:EmployeePortalPageProviderProps):JSX.Element
{
    React.useMemo(() => {
        applyPartnerColors(props.user?.partner);
    }, [props.user?.partner]);

    const styles = amorgStyles(colors);

    return (
        <EmployeePortalPageContext.Provider value={{
            user: props.user, 
            colors, 
            styles}}>

            {/* Type of theme is defined in styled.d.ts */}
            <ThemeProvider theme={{colors, styles}}>
                {props.children}
            </ThemeProvider>
        </ EmployeePortalPageContext.Provider>
    )
}